import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { KC_ROUTE, KC_CANONICAL, KC_SHARE_IMAGE, KC_JSONLD } from "@/lib/kccinemAssets";

const SITE = "https://moire.live";
const DEFAULT_OG_IMAGE = `${SITE}/og-image.png`;

const META = {
  "/": ["MOIRÉ — Dress Up. Don't Mess Up. | AI Fashion Stylist", "One piece. Your best matches. Zero guesswork. Your personal styling intelligence."],
  "/match": ["Match My Look — MOIRÉ", "Photograph any clothing item and discover the colours, shirts, shoes and accessories that pair best."],
  "/dont-mess-up": ["Don't Mess Up — MOIRÉ", "Check two pieces before you leave. MOIRÉ tells you how they work together and how to sharpen the look."],
  "/results": ["Your Matches — MOIRÉ", "Ranked colour pairings styled for your piece."],
  "/saved": ["Saved Looks — MOIRÉ", "Your styled pairings, saved."],
  "/wardrobe": ["My Wardrobe — MOIRÉ", "Save your own pieces and let MOIRÉ style from what you own."],
  "/style-me": ["Style Me — MOIRÉ", "Complete outfits built for your occasion, weather and style."],
  "/outfit-check": ["Outfit Check — MOIRÉ", "Photograph your full outfit for a cohesion score."],
  "/about": ["About — MOIRÉ", "A private stylist, always in reach. Powered by Kendi Collections."],
  "/collections/kc-cinem-003-1": [
    "KC-CINEM 003.1 — The Techcare Reaper | MOIRÉ by Kendi Collections",
    "Enter KC-CINEM 003.1 — The Techcare Reaper, an original fashion and costume concept created by Kendi Collections for MOIRÉ, exploring mask, modular outerwear, utility silhouettes and crimson-black design.",
  ],
  "/signin": ["Sign In — MOIRÉ", "Sign in to save your looks."],
  "/signup": ["Create Account — MOIRÉ", "Join MOIRÉ to save your styled pairings."],
  "/profile": ["Profile — MOIRÉ", "Your MOIRÉ profile and preferences."],
  "/privacy": ["Privacy — MOIRÉ", "How MOIRÉ handles your images and data."],
  "/terms": ["Terms — MOIRÉ", "MOIRÉ terms of service."],
};

// route-specific Open Graph / Twitter overrides
const OG = {
  [KC_ROUTE]: {
    title: "KC-CINEM 003.1 — The Techcare Reaper | MOIRÉ",
    description: "An original KC-CINEM fashion and costume concept created by Kendi Collections for MOIRÉ.",
    image: KC_SHARE_IMAGE,
  },
};

function upsertMeta(selector, attr, key, val) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", val);
}
const setProp = (prop, val) => upsertMeta(`meta[property="${prop}"]`, "property", prop, val);
const setName = (name, val) => upsertMeta(`meta[name="${name}"]`, "name", name, val);

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(obj) {
  const id = "route-jsonld";
  let el = document.getElementById(id);
  if (!obj) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const [title, desc] = META[pathname] || ["MOIRÉ — Dress Up. Don't Mess Up.", "Your personal styling intelligence."];
    document.title = title;
    setName("description", desc);

    const canonical = pathname === KC_ROUTE ? KC_CANONICAL : `${SITE}${pathname === "/" ? "/" : pathname}`;
    setCanonical(canonical);

    const og = OG[pathname];
    setProp("og:title", og?.title || title);
    setProp("og:description", og?.description || desc);
    setProp("og:url", canonical);
    setProp("og:image", og?.image || DEFAULT_OG_IMAGE);
    setName("twitter:title", og?.title || title);
    setName("twitter:description", og?.description || desc);
    setName("twitter:image", og?.image || DEFAULT_OG_IMAGE);

    setJsonLd(pathname === KC_ROUTE ? KC_JSONLD : null);
  }, [pathname]);
  return null;
}
